import { ChevronDown, ChevronUp } from "@components/Icons";
import clsx from "clsx";
import { isNonNullType } from "graphql";
import Link from "next/link";
import { Fragment } from "react";

import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";

const CategoryListbox = ({
	label,
	categories,
	selectedCategory,
	groupHandle,
}) => {
	return (
        <Menu>
			{({ open }) => (
				<div className="relative">
					<MenuButton className="relative w-full pl-4 pr-10 text-left border cursor-pointer h-15 bg-white-01 border-black-01 ">
						<span className={clsx("block truncate")}>{label}</span>
						<span className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
							{ open ? <ChevronUp  /> : <ChevronDown  />}
						</span>
					</MenuButton>

					<Transition
						show={open}
						as={Fragment}
						leave="transition ease-in duration-100"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<MenuItems
							className={clsx(
								"absolute z-10 w-full mt-1 overflow-auto text-base shadow bg-white-01 max-h-60 ring-opacity-5 focus:outline-none",
								"flex flex-col",
								"py-2"
							)}
						>
							{groupHandle === "resourceTypes" && (
								<MenuItem>
									{({ focus }) => (
										<Link
                      href="/resources/category/blog"
                      scroll={false}
                      className={clsx("px-4 py-3", "hover:bg-white-02", {
                          "bg-white-02": selectedCategory === "blog",
                      })}>
												Blog
										</Link>
									)}
								</MenuItem>
							)}
							{categories.map((category) => {
								const href = `/${category.uri}`;

								const isActive = category.id === selectedCategory?.id;

								return (
                                    <MenuItem key={category.id}>
										{({ focus }) => (
											(<Link
                                                href={href}
                                                scroll={false}
                                                className={clsx("px-4 py-3", "hover:bg-white-02", {
                                                    "bg-white-02": isActive,
                                                })}>

                                                {category.title}

                                            </Link>)
										)}
									</MenuItem>
                                );
							})}
						</MenuItems>
					</Transition>
				</div>
			)}
		</Menu>
    );
};

export default CategoryListbox;
